const getDateTimeString = (date: Date) => {
  if (!date) {
    return '';
  }

  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Toronto',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const dateParts: { [key: string]: string } = {};
  for (const part of parts) {
    if (part.type !== 'literal') {
      dateParts[part.type] = part.value;
    }
  }

  const formattedDate = `${dateParts.year}-${dateParts.month}-${dateParts.day}`;
  const formattedTime = `${dateParts.hour}:${dateParts.minute}:${dateParts.second}`;

  return `${formattedDate} ${formattedTime}`;
};

export default getDateTimeString;
